import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PortalLists from './PortalLists';
import { PortalList } from 'containers/user/Portal/PortalListingType';
import usePortalId from 'hooks/portal/usePortalId';

import { Button, DialogContent } from '@mui/material';
import { naviagteToHubspot } from 'containers/user/ConnectHubspot/ConnectToHubspot';
import { useTranslation } from 'react-i18next';

interface OwnProps {
  open: boolean;
  handleOpenClose: () => void;
  portals: PortalList[];
  disconnectPortal: (id: number) => void;
}
type Props = OwnProps;
const PortalListDialogue: React.FC<Props> = ({
  open,
  handleOpenClose,
  portals,
  disconnectPortal,
}) => {
  const { t } = useTranslation();
  const portalIdCurrent = usePortalId();

  return (
    <Dialog
      onClose={handleOpenClose}
      open={open}
      maxWidth='sm'
      fullWidth={true}
    >
      <DialogTitle className='text-center'>{t('hubspot_portals')}</DialogTitle>

      <DialogContent className='px-12 pt-12 pb-5 text-center'>
        <PortalLists
          currentPortalId={portalIdCurrent}
          handleOpenClose={handleOpenClose}
          portals={portals}
          disconnectPortal={disconnectPortal}
        />
        <Button
          onClick={naviagteToHubspot}
          color='info'
          variant='contained'
          sx={{
            width: '220px',
            margin: '20px auto 0 auto',
            marginBottom: '20px',
          }}
        >
          + {t('add_new_portal')}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
export default PortalListDialogue;
